import React from 'react';
import './style.css';

export default ( props )=>{

    const onChange = (e)=>{
        props.onChange(e.target.value);
    };

    return <input className='DefaultFilter' onChange={onChange} value={props.value} />
}


// WEBPACK FOOTER //
// ./src/App/components/Table/components/DefaultFilter/index.js